import axios from "axios";

export function isSignedIn() {
    return (localStorage.getItem("token") !== null)
}

const universityNames = [
    "Abertay University",
    "Aberystwyth University",
    "Anglia Ruskin University",
    "Arts University Bournemouth",
    "Aston University",
    "Bangor University",
    "Bath Spa University",
    "BIMM Institute London",
    "Birkbeck, University of London",
    "Birmingham City University",
    "Bishop Grosseteste University",
    "Bournemouth University",
    "BPP University",
    "Brunel University London",
    "Buckinghamshire New University",
    "Canterbury Christ Church University",
    "Cardiff Metropolitan University",
    "Cardiff University",
    "City, University of London",
    "Coventry University",
    "Cranfield University",
    "De Montfort University",
    "Durham University",
    "Edge Hill University",
    "Edinburgh Napier University",
    "European School of Economics",
    "Falmouth University",
    "Glasgow Caledonian University",
    "Goldsmiths, University of London",
    "Guildhall School of Music and Drama",
    "Harper Adams University",
    "Hartpury University and Hartpury College",
    "Heriot-Watt University",
    "Imperial College London",
    "Keele University",
    "King's College London",
    "Kingston University",
    "Lancaster University",
    "Leeds Arts University",
    "Leeds Beckett University",
    "Leeds Conservatoire",
    "Leeds Trinity University",
    "Liverpool Hope University",
    "Liverpool Institute for Performing Arts",
    "Liverpool John Moores University",
    "Liverpool School of Tropical Medicine",
    "London Business School",
    "London Metropolitan University",
    "London School of Hygiene and Tropical Medicine, University of London",
    "London South Bank University",
    "Loughborough University",
    "Manchester Metropolitan University",
    "Middlesex University",
    "Newcastle University",
    "Newman University, Birmingham",
    "Northeastern University London",
    "Northern School of Contemporary Dance",
    "Northumbria University",
    "Norwich University of the Arts",
    "Nottingham Trent University",
    "Oxford Brookes University",
    "Plymouth College of Art",
    "Plymouth Marjon University",
    "Queen Margaret University",
    "Queen Mary University of London",
    "Queen's University Belfast",
    "Ravensbourne University London",
    "Regent's University London",
    "Richmond, The American International University in London",
    "Robert Gordon University",
    "Rose Bruford College",
    "Royal Academy of Music, University of London",
    "Royal Agricultural University",
    "Royal College of Art",
    "Royal College of Music",
    "Royal Conservatoire of Scotland",
    "Royal Holloway, University of London",
    "Royal Northern College of Music",
    "Royal Veterinary College University of London",
    "School of Advanced Study, University of London",
    "Scotland's Rural College",
    "Sheffield Hallam University",
    "SOAS, University of London",
    "Solent University",
    "St George's, University of London",
    "St Mary's University, Twickenham",
    "Staffordshire University",
    "Swansea University",
    "Teesside University",
    "The Courtauld Institute of Art, University of London",
    "The Glasgow School of Art",
    "The London Institute of Banking and Finance",
    "The London School of Economics and Political Science",
    "The Royal Central School of Speech and Drama",
    "The University of Buckingham",
    "The University of Edinburgh",
    "The University of Hull",
    "The University of Law",
    "The University of Manchester",
    "The University of Northampton",
    "The University of Nottingham",
    "The University of Sheffield",
    "The University of Warwick",
    "The University of Winchester",
    "The University of York",
    "Trinity Laban Conservatoire of Music and Dance",
    "Ulster University",
    "University College Birmingham",
    "University College London",
    "University for the Creative Arts",
    "University of Aberdeen",
    "University of Bath",
    "University of Bedfordshire",
    "University of Birmingham",
    "University of Bolton",
    "University of Bradford",
    "University of Brighton",
    "University of Bristol",
    "University of Central Lancashire",
    "University of Chester",
    "University of Chichester",
    "University of Cumbria",
    "University of Derby",
    "University of Dundee",
    "University of East Anglia",
    "University of East London",
    "University of Essex",
    "University of Exeter",
    "University of Glasgow",
    "University of Gloucestershire",
    "University of Greenwich",
    "University of Hertfordshire",
    "University of Huddersfield",
    "University of Kent",
    "University of Leeds",
    "University of Leicester",
    "University of Lincoln",
    "University of Liverpool",
    "University of London",
    "University of Plymouth",
    "University of Portsmouth",
    "University of Reading",
    "University of Roehampton",
    "University of Salford",
    "University of South Wales",
    "University of Southampton",
    "University of St Andrews",
    "University of Stirling",
    "University of Strathclyde",
    "University of Suffolk",
    "University of Sunderland",
    "University of Surrey",
    "University of Sussex",
    "University of the Arts London",
    "University of the Highlands and Islands",
    "University of the West of England",
    "University of the West of Scotland",
    "University of Wales",
    "University of Wales Trinity Saint David",
    "University of West London",
    "University of Westminster",
    "University of Wolverhampton",
    "University of Worcester",
    "Wrexham Glyndwr University",
    "Writtle University College",
    "York St John University",
    "University of Oxford",
    "University of Cambridge"
]

export function sortedUniversityNames() {
    let sorted = [...universityNames]

    function stripUni(name: string) {
        return name.toLowerCase().replaceAll("university of", "").replaceAll("the ", "").replaceAll(" ", "")
    }

    sorted.sort((a,b) =>{
        if (stripUni(a) > stripUni(b)) {
            return 1
        } else if (stripUni(b) > stripUni(a)) {
            return -1
        } else {
            return 0
        }
    })

    sorted.push("Other")

    return sorted
}

export function handleError(error: any, quiet: boolean = false) {
    console.warn(error);

    try {
        if (error.response !== undefined) {
            const err = error.response.data.data.reason;
            if (err !== "Invalid Token" && err !== "Invalid Session") {
                alert(err);
            } else {
                console.log("Invalid Token");
            }
        } else {
            if (!quiet) {
                alert(error.code);
            }
        }
    } catch (e) {
        if (!quiet) {
            alert(error.code);
        }
        console.warn(e);
    }
}

export function truncate(input: string, n: number = 12) {
    if (input.length > n) {
        return input.substring(0, n) + '...';
    }
    return input;
}

export function signOut() {
    localStorage.removeItem("token");
    localStorage.removeItem("token-expiry");
    localStorage.removeItem("userData");
    localStorage.removeItem("options");

    setTimeout(() => {
        window.location.reload();
    }, 500)

    //window.dispatchEvent(new Event("sso-state"));
}

export const ssoPermsURL = "https://account.samaggisamagom.com/authenticate?req=e4b2924f-141b-4e89-b8f8-861d1bb20cae";
export const ssoURL = "https://account.samaggisamagom.com/authenticate?req=48040746-89db-4ec9-b2e5-b13b60f55fd8";


export async function checkToken() {
    return new Promise((resolve, ) => {
        if (!isSignedIn()) {
            resolve(false);
            return
        }

        const token = localStorage.getItem("token");

        if (token === null) {
            resolve(false);
            return
        }

        axios.post("https://k3rkw7qg78.execute-api.eu-west-2.amazonaws.com/Prod/api/check-token", {"token": token}).then(res => {
            console.log(res);
            try {
                if (res.data.data.valid === true) {
                    localStorage.setItem("token-expiry", res.data.data.expiry);
                    resolve(true)
                }
                resolve(false)
            } catch (e) {
                console.warn(e);
                resolve(false)
            }
        }).catch((error) => {
            console.warn(error)
            try {
                if (error.response !== undefined) {
                    alert(error.response.data.data.reason);
                } else {
                    //alert(error.message);
                }
            } catch (e) {
                //alert(error.message);
                console.warn(e);
            }
            resolve(false);
        })
    })
}
